import React from "react";
import DepartmentRuntimePage from "./DepartmentRuntimePage";

export default function MillingProductionPage() {
  return (
    <DepartmentRuntimePage
      department="milling"
      eyebrow="Production · Milling"
      title="Milling Department"
      description="Milling line runtime — de-huskers, polishers, and sorters. Additional milling metrics can be added here later."
      testId="milling-production-page"
      sectionEyebrow="Milling section"
    />
  );
}
